import { getEnvironmentName } from 'util/environment/name';

export const log = (...params) => {
  const environmentName = getEnvironmentName();
  if (environmentName !== 'prod') {
    console.log(...params);
  }
};
